import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  TemplateRef,
} from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { IUser } from 'src/app/core/models/user.model';
import { UserService } from 'src/app/core/services/user.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { Role } from 'src/app/core/models/role';
import { ToastrService } from 'ngx-toastr';
import { NgForm } from '@angular/forms';
import {
  NgbModal,
  NgbModalOptions,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { StorageService } from 'src/app/core/services/storage/storage.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { TranslateService } from '@ngx-translate/core';
import { ApplicationService } from 'src/app/core/services/application.service';
import { IClientModel, IClients } from 'src/app/core/models/application.model';

@Component({
  selector: 'app-user-item',
  templateUrl: './user-item.component.html',
  styleUrls: ['./user-item.component.css'],
})
export class UserItemComponent implements OnInit {
  @Input() user: IUser;
  @Input() applications;
  @Output() goToUser = new EventEmitter<string>();
  @Output() changeExteriorMax = new EventEmitter<string>();
  @Output() reloadUser = new EventEmitter<object>();
  @Output() deleteUser = new EventEmitter<string>();

  @ViewChild('dialogDeleteUser') private dialogDeleteUser: TemplateRef<any>;
  @ViewChild('dialogChangeUserApplication')
  private dialogChangeUserApplication: TemplateRef<any>;
  @ViewChild('dialogChangeExteriorMax') private dialogChangeExteriorMax;

  private dialogOptions: NgbModalOptions = {
    backdropClass: 'dark-backdrop',
    centered: true,
    windowClass: 'window-modal',
  };
  private modalChangeExteriorMax: NgbModalRef;

  selectedUser: IUser;
  usersData: IUser[];
  currentUser: IUser;

  toggleEditUser = false;
  userDevices = null;
  toggleMetadata = false;
  toggleDeleteNotifications = false;
  showClients = false;
  searchCustomersParam = '';
  filteredClients = [];
  selectedClient = null;

  constructor(
    private userService: UserService,
    private authService: AuthService,
    public router: Router,
    private toastr: ToastrService,
    private storageService: StorageService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private notificationsService: NotificationService,
    private translate: TranslateService,
    private applicationService: ApplicationService
  ) {}

  ngOnInit(): void {
    this.authService.LoggedinUser.subscribe((user) => {
      this.currentUser = user;
    });
  }

  navigateToUser(id: string) {
    this.goToUser.emit(id);
  }

  onMetadata(userId: string) {
    this.toggleMetadata = true;
    this.userDevices = null;

    this.userService.getUserDevices(userId).subscribe(
      (res) => {
        this.userDevices = res;
      },
      (err) => {}
    );
  }

  onEdit(user: IUser) {
    this.selectedUser = user;
    this.toggleEditUser = true;
  }

  editUser(form: NgForm) {
    if (!form.valid) {
      return this.translate.get('errors.pleaseFillRequiredField').subscribe((text: string) => {
        this.toastr.error(text);
      });
    }

    if (
      form.form.value.name.trim().length === 0 ||
      form.form.value.email.trim() === 0
    ) {
      return;
    }

    const editData = form.form.value;

    const body = {};

    Object.keys(this.selectedUser).forEach((key) => {
      if (key in editData) {
        if (
          editData[key] &&
          this.selectedUser[key] !== editData[key].trim() &&
          editData[key] !== 'additionalInvoiceInfo'
        ) {
          body[key] = editData[key].trim() === '' ? null : editData[key].trim();
        }
      }
    });

    if (
      this.selectedUser['additionalInvoiceInfo'] &&
      this.selectedUser['additionalInvoiceInfo'] !==
        editData['additionalInvoiceInfo']
    ) {
      body['additionalInvoiceInfo'] = editData['additionalInvoiceInfo'];
    }

    if (Object.keys(body).length === 0 && body.constructor === Object) {
      return;
    }

    this.userService.patchUser(body, this.selectedUser.id).subscribe(
      (res: IUser) => {
        this.toastr.success('User updated.');
        this.toggleEditUser = false;
        this.reloadUser.emit(res);
      },
      (error) => {
        this.toastr.error(error.message);
      }
    );
  }

  seeVehicles(id: string) {
    const roleName = this.currentUser.role.name;
    switch (roleName) {
      case Role.ROOT: {
        this.router.navigate([`root/users/${id}/vehicles`]);
        break;
      }
      case Role.CUSTOMER: {
        this.router.navigate([`customer/users/${id}/vehicles`]);
        break;
      }
      case Role.CLIENT: {
        this.router.navigate([`client/users/${id}/vehicles`]);
        break;
      }
      case Role.MANAGER: {
        this.router.navigate([`manager/${id}/vehicles`]);
        break;
      }
      default: {
        break;
      }
    }
  }

  seeCrops(id: string) {
    const roleName = this.currentUser.role.name;
    switch (roleName) {
      case Role.ROOT: {
        this.router.navigate([`root/users/${id}/crops`]);
        break;
      }
      case Role.CUSTOMER: {
        this.router.navigate([`customer/users/${id}/crops`]);
        break;
      }
      case Role.CLIENT: {
        this.router.navigate([`client/users/${id}/crops`]);
        break;
      }
      case Role.MANAGER: {
        this.router.navigate([`manager/${id}/crops`]);
        break;
      }
      default: {
        break;
      }
    }
  }

  loginUser(id: string) {
    const url = `${window.location.origin}/dashboard`;

    this.authService.loginUserAsRoot(id).subscribe(
      (res) => {
        this.storageService.setSessionObject(
          'user',
          JSON.stringify({ user: res.user, token: res.token })
        );
        this.storageService.setSessionObject(
          'userToken',
          JSON.stringify({ token: res.token })
        );
        window.open(url, '_blank');
      },
      (err) => {}
    );
  }

  deleteRequest(user) {
    const userId = user.id;
    this.deleteUser.emit(userId);
    this.modalDeleteUser.close();
  }

  modalDeleteUser;
  showDialogDeleteUser() {
    this.modalDeleteUser = this.modalService.open(
      this.dialogDeleteUser,
      this.dialogOptions
    );
  }

  clients: IClientModel[] | IClients;
  loadApplications() {
    this.applicationService.getAll(null, null, null)
      .subscribe(
        (response: IClientModel[] | IClients) => {
          this.clients = response;
          if (Array.isArray(response)) {
            this.clients = response.sort((a, b) =>
              a.name.localeCompare(b.name)
            );

          } else {
            this.clients = response.results.sort((a, b) =>
              a.name.localeCompare(b.name)
            );
          }
        
          this.filteredClients = this.clients;
          console.log(this.filteredClients)
          this.modalChangeUserApplication = this.modalService.open(
            this.dialogChangeUserApplication,
            this.dialogOptions
          );

          this.modalChangeUserApplication.result.then(
            (result) => {},
            (reason) => {}
          );
        });
  }

  userToChangeApplication;
  modalChangeUserApplication;
  showDialogChangeUserApplication(user) {
    // router.url == '/root/users'
    this.userToChangeApplication = user;
    if (this.router.url === '/root/users') {
      this.loadApplications();
    } else {
      this.filteredClients = this.applications.sort((a, b) => a?.name?.localeCompare(b.name));
      this.modalChangeUserApplication = this.modalService.open(
        this.dialogChangeUserApplication,
        this.dialogOptions
      );

      this.modalChangeUserApplication.result.then(
        (result) => {},
        (reason) => {}
      );
    }
  }

  openCustomers() {
    this.showClients = !this.showClients;
    this.searchCustomersParam = '';
    // this.customersSearch = this.customersData;

    this.applications = (this.applications || this.clients)?.sort((a, b) => a?.name?.localeCompare(b.name));
    this.filteredClients = this.applications;
  }

  applyCustomerFilter() {
    this.filteredClients = this.applications.filter(
      (client) =>
        client.name
          .toLowerCase()
          .indexOf(this.searchCustomersParam.toLowerCase()) !== -1
    );
  }

  selectClient(client) {
    this.selectedClient = client;
  }

  onCloseChangeClient() {
    this.selectedClient = null;
    this.modalChangeUserApplication.close();
  }

  sendChangeUserApplication() {
    if (!this.selectedClient) {
      this.translate.get('customer.enterApplicationError').subscribe((text: string) => {
        this.toastr.error(text);
      });
      return;
    }

    const clientId = this.selectedClient.id;

    if (this.userToChangeApplication.client.id === clientId) {
      this.translate.get('errors.userIsAlreadyInThatClient').subscribe((text: string) => {
        this.toastr.error(text);
      });
      return;
    }
    this.userService
      .changeApplication(this.userToChangeApplication.id, clientId)
      .subscribe(
        (res) => {
          this.toastr.success('Successfully changed user application');
          this.modalChangeUserApplication.close();
          this.selectClient = null;
          this.reloadUser.emit(res);
        },
        (error) => {
          this.toastr.error(error.message);
          this.modalChangeUserApplication.close();
        }
      );
    // this.router.navigate([], {
    //   relativeTo: this.route,
    //   queryParams: { clientId: applicationId },
    //   queryParamsHandling: 'merge',
    //   replaceUrl: true,
    // });
  }

  userToChangeExteriorMax: IUser;
  showDialogChangeExteriorMax(user) {
    this.userToChangeExteriorMax = user;
    this.modalChangeExteriorMax = this.modalService.open(
      this.dialogChangeExteriorMax,
      this.dialogOptions
    );
  }

  sendUserMaxExterior(form: NgForm) {
    if (form.form.value.exteriorMax >= 0) {
      this.userService
        .patchUserMaxCount(
          this.userToChangeExteriorMax.id,
          form.form.value.exteriorMax
        )
        .subscribe(
          (res) => {
            this.translate.get('user.successfullyChangedNumber').subscribe((text: string) => {
                this.toastr.success(text);
              });
            this.modalChangeExteriorMax.close();
            this.reloadUser.emit(res);
          },
          (error) => {
            if (error.errorCode === 4030050) {
              this.translate.get('errors.customerLimitExceeded').subscribe((text: string) => {
                this.toastr.error(text);
              });
            } else {
              this.toastr.error(error.message || 'An error occurred');
            }
          }
        );
    } else {
      this.translate.get('errors.minZeroNumber').subscribe((text: string) => {
        this.toastr.error(text);
      });
    }
  }

  deleteUserNotifications() {
    this.notificationsService.deleteNotifications(this.user.id).subscribe(
      (res) => {
        this.toastr.success('Notifications are deleted.');
        this.toggleDeleteNotifications = false;
      },
      (err) => {}
    );
  }
}
